<template>
	<StandardModal
		open
		small
		class="standard-alert-modal"
		:title="props.title"
		:confirmText="props.confirmText || $t('common_button_okay')"
		:cancelText="props.cancelText || $t('common_button_cancel')"
		:confirmProps="{ danger }"
		:hideCancel="props.hideCancel"
	>
		<slot>
			<div class="standard-alert-modal-content" :class="{ danger }">
				<component
					:is="props.icon || CircleExclamationIcon"
					type="regular"
					:halo="props.halo"
				/>
				<div v-text="props.description" />
			</div>
		</slot>
	</StandardModal>
</template>

<script setup>
import { CircleExclamationIcon } from '@/icons'
import { StandardModal } from '@/components/common'
import bus from '@/helpers/bus'

const props = defineProps({
	icon: Object,
	title: String,
	description: String,
	confirmText: { type: String, default: null },
	cancelText: String,
	hideCancel: { type: Boolean, default: true },
	halo: { type: Boolean, default: true },
	danger: { type: Boolean, default: true },
})
</script>

<script>
export function showAlertModal(options = {}) {
	// TODO: this should probably be tied into the component lifecyle similar to $onEventBus plugin
	// so that the modal automatically closes if/when the calling component unmounts
	console.debug('showing alert modal', options)
	bus.$emit('toggleAlertModal', {
		onConfirm: hideAlertModal,
		onCancel: hideAlertModal,
		...options,
	})
	return hideAlertModal
}
export function hideAlertModal() {
	console.debug('hiding alert modal')
	bus.$emit('toggleAlertModal', null)
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.standard-alert-modal {
	.standard-alert-modal-content {
		@include flex-column-center(16px);
		justify-content: center;
		height: 100%;
		padding: 16px 32px;
		&.danger {
			> .pronto-icon {
				color: var(--red-200);
			}
		}
		> .pronto-icon {
			font-size: 60px;
			color: var(--blue-300);
		}
	}
}
</style>
